export const SbMessageStreamTestIds = {
  lastRead: 'last_read_marker'
} as const;
